// @flow strict
import { useStaticQuery, graphql } from "gatsby"

const usePopularPosts = () => {
  const { popularPosts } = useStaticQuery(
    graphql`
      query PopularPostsBySlug {
        popularPosts: allMdx(
          filter: {
            fields: { slug: { in: ["/search/rackets/", "/search/strings/"] } }
          }
        ) {
          nodes {
            fields {
              slug
            }
            frontmatter {
              title
              thumbnail {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `
  )

  return popularPosts
}

export default usePopularPosts
